import React from 'react'

const Input = props => {
    const onMaxLengthInput = (e) => {
        if (props.maxLength) {
          if (props.maxLength > 0) {
            if (e.target.value.length > props.maxLength) {
              e.target.value = e.target.value.slice(0, props.maxLength);
            }
          }
        }
      }
    return (
        <div>
            <label className="text-sm block text-primary">{props.label}</label>
            <input onInput={onMaxLengthInput}  className={`w-full placeholder-opacity-50 bg-opacity-20 placeholder-primary px-4 py-2.5 leading-snug ${props.haserror ? "border-secondary focus:ring-secondary" : "border-transparent  focus:ring-primary" } border  rounded-md bg-primary focus:outline-none focus:ring-1`} type={props.type} value={props.value} placeholder={props.placeholder} {...props}/>
            <span class="text-xs text-red-700">{props.error}</span>
        </div>
    )
}

export default Input
